<div class="overlay"  *ngIf="run" >
    <div class="center">
    <mat-progress-spinner 
        [diameter]="diameter"
        [mode]="mode" 
        [color]="color"
        [strokeWidth]="strokeWidth"
        [value]="value">
    </mat-progress-spinner>
    </div>
</div>